import { Action } from '@ngrx/store';
import { TechnicalError } from '../../models/errors.model';
import { type } from '../util';

/**
 * For each action type in an action group, make a simple
 * enum object for all of this group's action types.
 *
 * The 'type' utility function coerces strings into string
 * literal types and runs a simple check to guarantee all
 * action types in the application are unique.
 */
export const ActionTypes = {
  REMOVE: type('[Alias] Remove'),
  REMOVE_SUCCESS: type('[Alias] Remove Success'),
  REMOVE_FAIL: type('[Alias] Remove Fail'),
  CREATE: type('[Alias] Create'),
  CREATE_SUCCESS: type('[Alias] Create Success'),
  CREATE_FAIL: type('[Alias] Create Fail'),
  RESET_SUCCESS: type('[Alias] Reset Success'),
  RESET_ERROR: type('[Alias] Reset Error'),
};

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */

export class RemoveAction implements Action {
  type = ActionTypes.REMOVE;

  constructor(public payload: string) {}
}

export class RemoveSuccessAction implements Action {
  type = ActionTypes.REMOVE_SUCCESS;

  constructor(public payload: { mbxId: string; aliasId: string }) {}
}

export class RemoveFailAction implements Action {
  type = ActionTypes.REMOVE_FAIL;

  constructor(public payload: TechnicalError) {}
}

export class CreateAction implements Action {
  type = ActionTypes.CREATE;

  constructor(public payload: string) {}
}

export class CreateSuccessAction implements Action {
  type = ActionTypes.CREATE_SUCCESS;

  constructor(public payload: { mbxId: string; aliasId: string }) {}
}

export class CreateFailAction implements Action {
  type = ActionTypes.CREATE_FAIL;

  constructor(public payload: TechnicalError) {}
}

export class ResetError implements Action {
  type = ActionTypes.RESET_ERROR;
  payload = null;
}

export class ResetSuccess implements Action {
  type = ActionTypes.RESET_SUCCESS;
  payload = null;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
  | RemoveAction
  | RemoveSuccessAction
  | RemoveFailAction
  | CreateAction
  | CreateSuccessAction
  | CreateFailAction
  | ResetError
  | ResetSuccess;
